import { Injectable } from '@angular/core';

import { CmsStructureModel, Occ, OccCmsPageNormalizer, Page } from '@spartacus/core';

@Injectable({ providedIn: 'root' })
export class DpOccCmsPageNormalizer extends OccCmsPageNormalizer {
  protected normalizePageData(source: Occ.CMSPage, target: CmsStructureModel): void {
    if (!source) {
      return;
    }
    const page: Page = {};

    if (source.name) {
      page.name = source.name;
    }
    if (source.typeCode) {
      page.type = source.typeCode;
    }
    if (source.label) {
      page.label = source.label;
    }
    if (source.template) {
      page.template = source.template;
    }
    if (source.uid) {
      page.pageId = source.uid;
    }
    if (source.title) {
      page.title = source.title;
    }
    if (source.metaTitle) {
      page.metaTitle = source.metaTitle;
    }
    if (source.description) {
      page.description = source.description;
    }
    if (source.properties) {
      page.properties = source.properties;
    }

    this.normalizeRobots(source, page);

    target.page = page;
  }
}
